import { REQUEST_QUEUE_SUCCESS, REQUEST_QUEUE_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { datas: [], errors: null };

export default function queue(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case REQUEST_QUEUE_SUCCESS:
      return { ...state, datas: action.payload.data, errors: null }
    case REQUEST_QUEUE_FAILURE:
      return { ...state, ids: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
